import {Component, EventEmitter, Injector, Output, ViewChild} from '@angular/core';
import {
  PortfolioModel,
  VISIBILITY_PRIVATE,
  VISIBILITY_PUBLIC,
  VISIBILITY_SHARED
} from "../../../shared/models/portfolio.model";
import {PortfolioShareDialogComponent} from "../portfolio-share-dialog/portfolio-share-dialog.component";
import {PortfolioCreateComponent} from "../portfolio-create/portfolio-create.component";
import {AuthService} from "../../../shared/services/auth.service";
import {User} from "../../../shared/models/user.model";
import {
  AssetTableColumnVisibilityFilterComponent
} from '../asset-table-column-visibility-filter/asset-table-column-visibility-filter.component';
import moment from "moment";
import {MatSnackBarRef, TextOnlySnackBar} from "@angular/material/snack-bar";
import {CompanyModel} from "../../../shared/models/company.model";
import { MaterialModule } from "src/app/app.materials";
import { ManualPortfolioFormComponent } from "../manual-portfolio-form/manual-portfolio-form.component";
import { NewPortfolioComponent } from "../portfolio-create/components/new-portfolio/new-portfolio.component";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SearchPipe } from 'src/app/shared/services/search.pipe';

@Component({
  selector: 'app-portfolio-edit',
  templateUrl: './portfolio-edit.component.html',
  imports: [MaterialModule, ManualPortfolioFormComponent, AssetTableColumnVisibilityFilterComponent, NewPortfolioComponent, FormsModule, CommonModule, SearchPipe],
  standalone: true,
})



export class PortfolioEditComponent extends PortfolioCreateComponent {
  portfolio: PortfolioModel;
  isPublic = false;
  publicToggle = false;
  isTutorial = false;
  tutorialToggle = false;

  currentUser: User = null;

  type = null;
  drawlerData: any = {};
  selectedFilters = {};

  filters = {};
  @ViewChild('drawer') drawer: any;
  @ViewChild('stockFilters') stockFilters: AssetTableColumnVisibilityFilterComponent;
  @Output() startDateChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() startingDate: EventEmitter<any> = new EventEmitter<any>();


  constructor(injector: Injector, private auth: AuthService) {
    super(injector);
    this.storage.sideMenuObjectChange.subscribe((data) => {
      this.type = data.type;
      this.drawlerData = data;
      data.drawer && this.drawer && this.drawer.toggle();
    })
  }

  initPage() {

    this.auth.getCurrentUser().subscribe((resp) => {
      if (resp) {
        this.currentUser = new User(resp);
      }
    })

    const id = +this.route.snapshot.paramMap.get('id');
    this.getPortfolio(id);
  }

  getPortfolio(id?) {
    this.service.getItem(id).subscribe((resp: any) => {

      if (resp.item) {
        this.portfolio = new PortfolioModel(resp.item);
        this.onPortfolioLoaded();

        if (!this.portfolio.isGenerated()) {
          this.selected = this.portfolio.securities;
          this.sortSelectedList();
        }
        if (this.portfolio.currency_hedging.length) {
          this.extractCurrencyHedging();
        } else {
          this.updateSelectedCurrencyList();
        }
      }
    })
  }

  onPortfolioLoaded() {
    this.isPublic = this.portfolio.isPublic();
    this.isTutorial = this.portfolio.is_tutorial == 1;
  }

  togglePublic() {
    this.isPublic = !this.isPublic;
    this.publicToggle = this.isPublic;
    this.portfolio.visibility = this.isPublic ? VISIBILITY_PUBLIC : VISIBILITY_PRIVATE;

    this.simpleSavePortfolio(`Portfolio is now ${this.isPublic ? 'public' : 'private'}`)
  }

  onTutorialToggle() {
    this.isTutorial = !this.isTutorial;
    this.tutorialToggle = this.isTutorial;
    this.portfolio.is_tutorial = this.isTutorial ? 1 : 0;

    if (this.isTutorial) {
      this.isPublic = true;
      this.publicToggle = true;
    } else {
      this.isPublic = false;
      this.publicToggle = false;
    }
    this.portfolio.visibility = this.isPublic ? VISIBILITY_PUBLIC : VISIBILITY_PRIVATE;

    this.simpleSavePortfolio(`Portfolio is now ${this.isTutorial ? 'tutorial' : 'private'}`)
  }

  simpleSavePortfolio(successMsg = 'Saved') {
    const hedging = this.portfolio.currency_hedging;
    delete this.portfolio.currency_hedging;
    this.service.saveItem(this.portfolio).subscribe(resp => {
      if (resp.error) {
        return this.service.notificationService.open(resp.error)
      }
      this.portfolio.currency_hedging = hedging;
      this.service.notificationService.open(successMsg);
    })
  }


  unShare() {
    this.service.unshareItem(this.portfolio.id).subscribe((resp: any) => {
      this.togglePublic();
    })
  }

  onPublicToggle() {
    // Unshare before changing visibility
    if (this.portfolio.visibility === VISIBILITY_SHARED) {
      this.service.confirmAction().subscribe(confirm => {
        if (confirm) {
          this.unShare();
        } else {
          this.publicToggle = false;
        }
      })
    } else {
      this.togglePublic();
    }
  }

  onShareClick() {
    if (this.portfolio.isPublic()) {
      return false;
    }
    const dialogRef = this.dialog.open(PortfolioShareDialogComponent, {
      data: { portfolio: this.portfolio },
      maxWidth: '600px',
      autoFocus: false,
      width: '100%'
    });
    dialogRef.afterClosed().subscribe( (resp: any) => {
      if (resp) {
        this.portfolio = new PortfolioModel(resp.portfolio);
      }
    });
  }

  onUnshareClick() {
    this.service.unshareItem(this.portfolio.id).subscribe((resp: any) => {
      this.portfolio.visibility = VISIBILITY_PRIVATE;
    });
  }

  protected override startPortfolioPolling(portfolioId: number, portfolioName: string = '', initialDelay = 5000) {
    let hasSeenComputing = false;
    let pollCount = 0;
    const MAX_POLLS_WITHOUT_COMPUTING = 20;

    this.portfolioPollingService.watchPortfolio(portfolioId, {
      onNext: (response) => {
        pollCount++;
        if (response?.item?.status === 1) {
          hasSeenComputing = true;
        }
      },
      shouldComplete: () => hasSeenComputing || pollCount >= MAX_POLLS_WITHOUT_COMPUTING,
      onStatusComplete: () => {
        this.service.notificationService.openWithAction(
          'Portfolio ' + portfolioName + ' computation finished',
          'Open',
          '/app/portfolio-view/' + portfolioId + '/overview'
        );
        this.service.portfolioFinished.next({id: portfolioId});
      },
      pollingInterval: 6000,
      initialDelay,
      listenerKey: `portfolio-${portfolioId}`,
      context: this
    });
  }

  protected override afterSavePortfolio(portfolioId: number, portfolioName: string) {
    this.service.pendingComputingPortfolioId = portfolioId;
    this.startPortfolioPolling(portfolioId, portfolioName);
    this.router.navigate(['/app']);
  }

  onClickCart() {
    this.onPortfolioCartClick();
  }

   handleCheckboxUpdate(id) {
    if(!this.selectedFilters[id]) {
      this.selectedFilters[id] = true;
      return;
    }
    this.selectedFilters[id] = !this.selectedFilters[id];
  }

  filterCompanies() {
    const ids = Object.keys(this.selectedFilters).filter((v) => +this.selectedFilters[v]);
    if(this.drawlerData.modelChanged) {
      this.drawlerData.modelChanged.emit(ids);
    } else {
      // clean the colums that are no longer used
      Object.keys(this.columnVisibility).forEach((v) => {
        if(this.columnVisibility[v] === false && document.getElementsByClassName(v)[0]) {
          (document.getElementsByClassName(v)[0].children[1] as any).click();
        }
      });
    }
  }

  onOpenedChange(event) {
    if(!event) {
      this.filterCompanies();
    }
  }
}
